import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import SummaryHeaderContent from './SummaryHeaderContent';
import SummaryHeaderOwnedBy from './SummaryHeaderOwnedBy';
import SummaryHeaderButtons from './SummaryHeaderButtons';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryHeader = ({
  documentId,
  documentMetadata,
  gdprSettings,
  updateDocument,
  onPercentProgress,
  removeDocument,
  downloadDocument,
  uploadFile,
  importFile,
  updateDocumentGDPRSetting
}) => {
  return /*#__PURE__*/_jsxs(View, {
    id: "summary-header",
    paddingBlockEnd: "500",
    as: "header",
    children: [/*#__PURE__*/_jsx(Breadcrumbs, {
      marginBlockEnd: "300",
      flush: true,
      children: /*#__PURE__*/_jsx(UIRouterLink, {
        to: "/",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.header.breadcrumb"
        })
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      maxInlineSize: "100%",
      children: [/*#__PURE__*/_jsx(SummaryHeaderContent, {
        documentId: documentId,
        documentMetadata: documentMetadata,
        gdprSettings: gdprSettings,
        updateDocument: updateDocument,
        updateDocumentGDPRSetting: updateDocumentGDPRSetting
      }), /*#__PURE__*/_jsx(SummaryHeaderOwnedBy, {
        documentId: documentId,
        documentMetadata: documentMetadata
      }), /*#__PURE__*/_jsx(SummaryHeaderButtons, {
        documentMetadata: documentMetadata,
        gdprSettings: gdprSettings,
        onPercentProgress: onPercentProgress,
        removeDocument: removeDocument,
        downloadDocument: downloadDocument,
        uploadFile: uploadFile,
        importFile: importFile
      })]
    })]
  });
};
export default SummaryHeader;